import { useTranslation } from 'modules/domains/list';
import { Avatar, AVATAR_SIZES } from 'ui/avatar';
import { Trans } from 'react-i18next';
import { Tooltip } from 'ui/tooltip';
import { parseDate } from 'utils/datetime';
import { isEmptyString } from 'utils/stringHelpers';
import { DATE_FORMAT_WITH_COMMA_HOUR_MINS_WITH_TIMEZONE } from 'utils/date';
import { useDisplayDate, useDisplayDateWithDayWeekMonthYearPrefix } from 'utils/hooks/datetime';
import {
  StyledInnerContainer,
  DateContainer,
  LastModifiedDate,
  CreatedContainer,
  TooltipContainer,
} from './LastModifiedCell.styles';
import { StyledTableCell } from '../styles';
import { CellProps } from '../types';
import { LIST_COLUMNS } from '../../../types';
import { useListsContext } from '../../../contexts';

export const LastModifiedCell = ({ row: list }: CellProps) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  const displayDateWithYesterdayAndTodayPrefix = useDisplayDateWithDayWeekMonthYearPrefix();
  const { listCreators } = useListsContext();

  const updatedAt = displayDate(
    parseDate(list.updatedAt),
    DATE_FORMAT_WITH_COMMA_HOUR_MINS_WITH_TIMEZONE,
  );
  const createdAt = displayDateWithYesterdayAndTodayPrefix(parseDate(list.createdAt), false);
  const listCreatorsData = listCreators?.[list.creatorUserId];
  const createdBy = listCreatorsData?.fullName ?? list.creatorUserId;

  const modifierEmail = !isEmptyString(list.updatedByUserId)
    ? list.updatedByUserId
    : list.creatorUserId;
  const [modifierFirstName, modifierLastName] = listCreatorsData?.fullName.split(' ') ?? [
    modifierEmail,
    '',
  ];

  return (
    <StyledTableCell>
      <StyledInnerContainer>
        <Tooltip
          tooltipContent={
            <TooltipContainer>
              <div>{listCreatorsData && listCreatorsData.fullName}</div>
              <div>{modifierEmail}</div>
            </TooltipContainer>
          }
        >
          <Avatar
            imgSrc={listCreatorsData?.avatarUrl ?? undefined}
            firstName={modifierFirstName}
            lastName={modifierLastName}
            size={AVATAR_SIZES.MEDIUM}
          />
        </Tooltip>
        <DateContainer>
          <LastModifiedDate>{updatedAt}</LastModifiedDate>
          <CreatedContainer>
            <Trans
              t={t}
              i18nKey={`indexPage.table.columns.${LIST_COLUMNS.lastModifiedBy}.created`}
              values={{ createdAt }}
              components={{
                Tooltip: (
                  <Tooltip
                    isUnderlined
                    tooltipContent={
                      <TooltipContainer>
                        <div>{updatedAt}</div>
                        <div>
                          {t(`indexPage.table.columns.${LIST_COLUMNS.lastModifiedBy}.createdBy`, {
                            createdBy,
                          })}
                        </div>
                      </TooltipContainer>
                    }
                  >
                    {createdAt}
                  </Tooltip>
                ),
              }}
            />
          </CreatedContainer>
        </DateContainer>
      </StyledInnerContainer>
    </StyledTableCell>
  );
};
